import { useDrag, useDrop } from 'react-dnd';
import { NavbarItem } from '@typedream/core';
import { NavbarMenuItemProps } from '@typedream/components';
import { useTPlateEditorRef } from '../../../plate';

export enum NAVBAR_DRAGGABLE_TYPE {
  ITEM_END = 'navbar_item_end',
  ITEM_MID = 'navbar_item_mid',
}

export const useMenuItemDnd = (props: Omit<NavbarMenuItemProps<NavbarItem>, 'onClick'>) => {
  const editor = useTPlateEditorRef();

  const [dropCollector, drop] = useDrop({
    accept: [NAVBAR_DRAGGABLE_TYPE.ITEM_END, NAVBAR_DRAGGABLE_TYPE.ITEM_MID],
    drop: (dropItem: { index: number }, monitor) => {
      // is it mid or end?
      const isDraggedItemEndMenu = monitor.getItemType() === NAVBAR_DRAGGABLE_TYPE.ITEM_END;

      // get the hover direction, is it left or right?
      editor.emitter.emit('toolbar:navbar:menu-item:drop', {
        to: { index: props.index, endMenu: props.endMenu },
        from: { index: dropItem.index, endMenu: isDraggedItemEndMenu },
      });
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const [dragCollector, drag] = useDrag({
    type: props.endMenu ? NAVBAR_DRAGGABLE_TYPE.ITEM_END : NAVBAR_DRAGGABLE_TYPE.ITEM_MID,
    item: { index: props.index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return {
    drop,
    drag,
    dropCollector,
    dragCollector,
  };
};
